import { Grid } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import {
  updateShipBackAddresses,
  updateShipBackDestination,
} from "actions/item";
import PopupMoreDetailsShipbackOptions from "components/popups/popupMoreDetailsShipbackOptions";
import ShipBackAddressUpdatePopup from "components/popups/shipBackAddressUpdatePopup";
import ShipBackDestinationUpdatePopup from "components/popups/shipBackDestinationUpdatePopup";
import {
  googleApiKey,
  INSURANCE_CERTIFICATE_LINK,
} from "helpers/ApplicationHelper";
import UserActions from "lib/userActions";
import React from "react";
import { useDispatch } from "react-redux";
import {
  getDistanceString,
  getFormattedAddress,
  getGoogleMapsDirectionLink,
  getShipBackText,
  getStep,
  gridClasses,
  setLsItemsShippingInfo,
} from "./helpers";
import MarkerIcon from "./MarkerIcon";
import { PencilIcon } from "components/common";
import ShieldIcon from "./ShieldIcon";

const ShipBackItem = (props) => {
  const dispatch = useDispatch();
  const {
    item: { id, shipback_info },
  } = props;
  const isDirect = shipback_info.shipping_option === "direct";
  const sellerAddress = getFormattedAddress(shipback_info.address);
  const shippingAddress = getFormattedAddress(
    isDirect ? shipback_info.address : shipback_info.shipping_center_address
  );
  const distanceToShippingCenter = getDistanceString(
    shipback_info.shipping_center_address?.distance
  );
  const step = getStep(shipback_info.bundle_workflow_state);

  const onMapClick = () => {
    const directionsLink = getGoogleMapsDirectionLink(
      sellerAddress,
      shippingAddress
    );
    window.open(directionsLink, "_blank");
  };

  const onAddressSave = async (address) => {
    const { payload } = await dispatch(
      updateShipBackAddresses(id, {
        address,
        shipping_option: shipback_info.shipping_option,
      })
    );
    setLsItemsShippingInfo(shipback_info, payload);
  };

  const onDestinationSave = async (destination) => {
    const { address, shipping_center_address } = shipback_info;
    const { payload } = await dispatch(
      updateShipBackDestination(id, {
        address,
        shipping_center_address,
        shipping_option: destination,
      })
    );
    setLsItemsShippingInfo(shipback_info, payload);
  };

  const onAddressModalOpen = () => {
    ShipBackAddressUpdatePopup.initPopup({
      formattedAddress: sellerAddress,
      showAddressLine2: true,
      onSave: onAddressSave,
    });
  };

  const onDestinationModalOpen = () => {
    ShipBackDestinationUpdatePopup.initPopup({
      formattedAddress: sellerAddress,
      destination: shipback_info.shipping_option,
      onSave: onDestinationSave,
    });
  };

  const onMoreDetailsModalOpen = () => {
    const event = "shipment option - more info";
    UserActions.myAccount(event, props.item.id, "Item");
    PopupMoreDetailsShipbackOptions.initPopup({});
  };

  return (
    <div className="shipBack--card shipBack--card-responsive-text">
      <Grid container>
        {shipback_info.items.map((item) => {
          if (item.workflow_state !== "return_pending") {
            return null;
          }
          return (
            <React.Fragment key={item.public_id}>
              <Grid item xs={12} classes={gridClasses}>
                <div className="shipBack--text">#{item.public_id}</div>
              </Grid>
              <Grid item xs={12} classes={gridClasses}>
                <h2 className="shipBack--subheader">{item.description}</h2>
              </Grid>
              <Grid item xs={12} classes={gridClasses}>
                <Divider light style={{ margin: "10px 0 15px" }} />
              </Grid>
            </React.Fragment>
          );
        })}
        {step === 0 && !isDirect && (
          <Grid item xs={12} classes={gridClasses} style={{ marginBottom: 16 }}>
            <div className="shipBack--banner">
              <p className="shipBack--text">
                This FedEx location was pre-selected based on your address.
                <br />
                <a
                  className="shipBack--button-editAddress"
                  onClick={onAddressModalOpen}
                >
                  Edit address
                </a>{" "}
                to change location.
              </p>
            </div>
          </Grid>
        )}
        <Grid container style={{ marginBottom: 16 }}>
          <Grid item xs className="shipBack--grid-width20-desktop">
            <div className="shipBack--text shipBack--text-normal">
              {getShipBackText("shipTo")}
            </div>
          </Grid>
          <Grid item xs={12} md classes={gridClasses}>
            <Grid container>
              <Grid
                item
                xs={12}
                classes={gridClasses}
                style={{ display: "flex" }}
              >
                <div className="shipBack--text shipBack--text-bold shipBack--text-d-flex shipBack--text-w-100 shipBack--mb-8 shipBack--mb-xs-4">
                  {isDirect
                    ? getShipBackText("specifiedAddress")
                    : `${getShipBackText("fedExShippingCenter")}`}
                  {!isDirect && <> ({distanceToShippingCenter})</>}
                  {step === 0 && (
                    <button
                      className="shipBack--button shipBack--button-icon shipBack--button-editDestination"
                      onClick={onDestinationModalOpen}
                    >
                      <PencilIcon />
                      <span>{getShipBackText("edit")}</span>
                    </button>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} classes={gridClasses}>
                {shippingAddress ? (
                  <>
                    <MarkerIcon
                      style={{ marginRight: 6, verticalAlign: "middle" }}
                    />
                    <div className="shipBack--text">{shippingAddress}</div>
                    <div className="shipBack--map-container">
                      <img
                        key={shippingAddress}
                        src={`https://maps.googleapis.com/maps/api/staticmap?center=${shippingAddress}&zoom=16&size=320x180&maptype=roadmap&markers=color:0x2D5DEC|${shippingAddress}&key=${googleApiKey}&style=feature:poi|element:labels|visibility:off`}
                        onClick={onMapClick}
                      />
                    </div>
                  </>
                ) : (
                  <div className="shipBack--text shipBack--text-error">
                    {getShipBackText("addressNotDetermined")}
                  </div>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                classes={gridClasses}
                style={{ marginRight: 20, maxWidth: isDirect ? 337 : 440 }}
              >
                <Grid container wrap="nowrap">
                  <Grid item>
                    <ShieldIcon
                      isActive={!isDirect}
                      style={{ marginRight: 8, marginTop: 4 }}
                    />
                  </Grid>
                  <Grid
                    item
                    style={{
                      lineHeight: "16px",
                    }}
                  >
                    {isDirect ? (
                      <div className="shipBack--text shipBack--text-small shipBack--fs-xs-10">
                        {getShipBackText("securityRecommendationDirect")}
                      </div>
                    ) : (
                      <>
                        <div className="shipBack--text shipBack--text-bold-700 shipBack--text-inline shipBack--text-small shipBack--fs-xs-10">
                          {getShipBackText("securityRecommendation")}
                          {": "}
                        </div>
                        <div className="shipBack--text shipBack--text-inline shipBack--text-small shipBack--fs-xs-10">
                          {getShipBackText("securityRecommendationHAL")} (
                          <a onClick={onMoreDetailsModalOpen}>
                            {getShipBackText("securityRecommendationHALLink")}
                          </a>
                          )
                        </div>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {isDirect && (
          <Grid container style={{ marginBottom: 16 }}>
            <Grid item xs className="shipBack--grid-width20-desktop">
              <div className="shipBack--text shipBack--text-normal">
                {getShipBackText("yourAddress")}
              </div>
            </Grid>
            <Grid item xs={12} md classes={gridClasses}>
              {sellerAddress ? (
                <>
                  <div
                    className="shipBack--text shipBack--text-d-flex shipBack--text-w-100"
                    style={{ marginBottom: 4 }}
                  >
                    {sellerAddress}
                    {step === 0 && (
                      <button
                        className="shipBack--button shipBack--button-icon shipBack--button-editAddress"
                        onClick={onAddressModalOpen}
                      >
                        <PencilIcon />
                        <span>{getShipBackText("edit")}</span>
                      </button>
                    )}
                  </div>
                  <div
                    className="shipBack--text shipBack--text-small shipBack--text-normal shipBack--fs-xs-10"
                    style={{ marginRight: 20 }}
                  >
                    {isDirect
                      ? getShipBackText("yourAddressFinePrintDirect")
                      : getShipBackText("yourAddressFinePrintHAL")}
                  </div>
                </>
              ) : (
                <div className="shipBack--text shipBack--text-error">
                  {getShipBackText("addressNotDetermined")}
                </div>
              )}
            </Grid>
          </Grid>
        )}
        <Grid container>
          <Grid item xs className="shipBack--grid-width20-desktop">
            <div className="shipBack--text shipBack--text-normal">
              {getShipBackText("insurance")}
            </div>
          </Grid>
          <Grid item xs={12} md classes={gridClasses}>
            {isDirect ? (
              <div className="shipBack--text">
                <a
                  href={INSURANCE_CERTIFICATE_LINK}
                  target="_blank"
                  rel="noreferrer"
                >
                  {getShipBackText("insuranceCoverageReleaseFormLink")}
                </a>
                {getShipBackText("insuranceCoverageReleaseForm")}
              </div>
            ) : (
              <div className="shipBack--text">
                {getShipBackText("insuranceCoverage")}
                <a
                  href={INSURANCE_CERTIFICATE_LINK}
                  target="_blank"
                  rel="noreferrer"
                >
                  {getShipBackText("insuranceCoverageLink")}
                </a>
              </div>
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ShipBackItem;
